/**
 * Loading / empty / error blocks.
 *
 * WHY they are components and not ad-hoc markup: an empty payout list is the normal state for a
 * freshly connected store, so "nothing here" has to explain *why* there is nothing and what
 * happens next. A blank panel would read as a broken page.
 */
import type { ReactNode } from "react";

export function Loading({ label = "Loading" }: { label?: string }): ReactNode {
  return (
    <div className="state" role="status" aria-live="polite">
      <span className="spinner" aria-hidden="true" />
      <span>{label}…</span>
    </div>
  );
}

export function EmptyState({ title, hint, action }: { title: string; hint?: string; action?: ReactNode }): ReactNode {
  return (
    <div className="state state-empty">
      <p className="state-title">{title}</p>
      {hint ? <p className="state-hint">{hint}</p> : null}
      {action}
    </div>
  );
}

export function ErrorState({ error, onRetry }: { error: Error; onRetry?: () => void }): ReactNode {
  return (
    <div className="state state-error" role="alert">
      <p className="state-title">Could not load this view</p>
      <p className="state-hint">{error.message}</p>
      {onRetry ? <button type="button" className="btn" onClick={onRetry}>Try again</button> : null}
    </div>
  );
}
